module.exports = __webpack_public_path__ + "media/assets/images/flags/er-4b4192acb15d1c7795056ff5cf6237f1.svg";